"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateSectionsByDate = exports.getItem = exports.getSectionHeaderForRow = exports.getTotalRows = exports.isSections = void 0;

var lodash_1 = require("lodash");

var moment_1 = __importDefault(require("moment"));

function isSections(items) {
  var _a;

  return !!((_a = items[0]) === null || _a === void 0 ? void 0 : _a.items);
}

exports.isSections = isSections;

function getTotalRows(numColumns, items) {
  if (isSections(items)) {
    return items.reduce(function (acc, section) {
      return acc + Math.ceil(section.items.length / numColumns) + 1;
    }, 0);
  } else {
    return Math.ceil(items.length / numColumns);
  }
}

exports.getTotalRows = getTotalRows;

function getSectionHeaderForRow(rowIndex, numColumns, items) {
  if (isSections(items)) {
    var currentRow = -1;

    var _iterator = _createForOfIteratorHelper(items),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var section = _step.value;
        currentRow++;
        if (rowIndex === currentRow) return section;
        var numRows = Math.ceil(section.items.length / numColumns);
        currentRow += numRows;
        if (rowIndex <= currentRow) return null;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return null;
  } else return null;
}

exports.getSectionHeaderForRow = getSectionHeaderForRow;

function getItem(rowIndex, columnIndex, numColumns, items) {
  if (isSections(items)) {
    var currentRowIndex = -1;

    var _iterator2 = _createForOfIteratorHelper(items),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var section = _step2.value;
        currentRowIndex++; // For the title.

        var sectionItem = section.items[(rowIndex - currentRowIndex - 1) * numColumns + columnIndex];

        if (sectionItem) {
          return sectionItem;
        }

        var numRows = Math.ceil(section.items.length / numColumns);
        currentRowIndex += numRows;
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return null;
  } else {
    return items[rowIndex * numColumns + columnIndex] || null;
  }
}

exports.getItem = getItem;
var DATE_ZONES = [{
  filter: function filter(date) {
    return (0, moment_1.default)(date).isAfter((0, moment_1.default)());
  },
  format: function format() {
    return 'Up Next';
  }
}, {
  filter: function filter(date) {
    return (0, moment_1.default)(date).isSame((0, moment_1.default)(), 'day');
  },
  format: function format() {
    return 'Today';
  }
}, {
  filter: function filter(date) {
    return (0, moment_1.default)(date).isSame((0, moment_1.default)().subtract(1, 'day'), 'day');
  },
  format: function format() {
    return 'Yesterday';
  }
}, {
  filter: function filter(date) {
    return (0, moment_1.default)(date).isSame((0, moment_1.default)(), 'week');
  },
  format: function format(date) {
    return (0, moment_1.default)(date).format('dddd');
  }
}, {
  filter: function filter(date) {
    return (0, moment_1.default)(date).isSame((0, moment_1.default)().subtract(1, 'week'), 'week');
  },
  format: function format() {
    return 'Last Week';
  }
}, {
  filter: function filter(date) {
    return (0, moment_1.default)(date).isSame((0, moment_1.default)().subtract(2, 'week'), 'week');
  },
  format: function format() {
    return '2 Weeks Ago';
  }
}, {
  filter: function filter(date) {
    return (0, moment_1.default)(date).isSame((0, moment_1.default)().subtract(3, 'week'), 'week');
  },
  format: function format() {
    return '3 Weeks Ago';
  }
}, {
  filter: function filter(date) {
    return (0, moment_1.default)(date).isAfter((0, moment_1.default)().subtract(1, 'year'));
  },
  format: function format(date) {
    return (0, moment_1.default)(date).format('MMMM YYYY');
  }
}, {
  filter: function filter() {
    return true;
  },
  format: function format(date) {
    return (0, moment_1.default)(date).format('YYYY');
  }
}];

function generateSectionsByDate(items) {
  var grouped = (0, lodash_1.groupBy)(items, function (item) {
    var _iterator3 = _createForOfIteratorHelper(DATE_ZONES),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var dateZone = _step3.value;

        if (dateZone.filter(item.date)) {
          return dateZone.format(item.date);
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    return DATE_ZONES[DATE_ZONES.length - 1].format(item.date);
  });
  return (0, lodash_1.orderBy)(Object.keys(grouped), function (key) {
    return grouped[key][0].date;
  }, 'desc').map(function (group) {
    return {
      title: group,
      items: grouped[group]
    };
  });
}

exports.generateSectionsByDate = generateSectionsByDate;